<script lang="ts">
    import {_} from 'svelte-i18n'
    import Dialog, {Actions, Content, Title} from '@smui/dialog';
    import Button, {Label} from '@smui/button';
    import type {Conversation, ConversationEndDialogResult, DefinedMessage, DialogCancel, MessageInputResult} from './types';
    import {DefinedMessageType} from './types';
    import ConversationName from './ConversationName.svelte';
    import MessageInput from './MessageInput.svelte';
    import {definedMessageService, mySession} from './services';
    import {get} from 'svelte/store';

    const CONFIRM_ACTION_NAME = 'dialog-confirm';
    const INITIAL_VALUE = '';

    let conversation: Conversation;
    let dialogOpened;
    let endingMessage: string = INITIAL_VALUE;
    let endingMessageValid: boolean = false;

    let dialogResolve;
    let dialogReject;

    function submitResult() {
        if (!endingMessageValid) {
            return;
        }
        const result: ConversationEndDialogResult = {
            author: get(mySession),
            messageText: endingMessage
        }
        dialogResolve(result);
    }

    function cancelResult() {
        const dialogCancel: DialogCancel = {
            byUser: true
        };
        dialogReject(dialogCancel);
    }

    function closeHandler(e: CustomEvent) {
        if (e.detail.action === CONFIRM_ACTION_NAME) {
            return submitResult();
        }
        return cancelResult();
    }

    function onMessageInputSubmit(e: CustomEvent<void>) {
        dialogOpened = false;
        return submitResult();
    }

    export async function open(dialogConversation: Conversation) {
        conversation = dialogConversation;
        dialogOpened = true;

        if (endingMessage === INITIAL_VALUE) {
            let primaryMessage = await definedMessageService.getPrimaryOfTypeOrNull(DefinedMessageType.OPERATOR_CHAT_ENDING_MESSAGE);
            if (endingMessage === INITIAL_VALUE && primaryMessage !== null) {
                endingMessage = primaryMessage.text;
            }
        }

        return await new Promise<MessageInputResult>((resolve, reject) => {
            dialogResolve = resolve;
            dialogReject = reject;
        });
    }
</script>

<Dialog bind:open={dialogOpened} aria-labelledby="dialog-title-conversation-end" aria-describedby="dialog-content-conversation-end" on:MDCDialog:closed={closeHandler}>
    {#if conversation}
        <Title id="dialog-title-conversation-end">{$_('chat.ReallyEndChat')}?</Title>
        <Content id="dialog-content-conversation-end">
            <div style="margin: 10px 0 5px 0;">
                {$_('chat.ReallyEndChat')} <strong><ConversationName conversation={conversation} /></strong>?
                <br/>
                {$_('chat.YouCanLeaveLastMessage')}
            </div>
            <div style="margin: 20px 0 5px 0;">
                <MessageInput bind:value={endingMessage} bind:valueValid={endingMessageValid} on:message-submit={onMessageInputSubmit} predefinedMessagesType={DefinedMessageType.OPERATOR_CHAT_ENDING_MESSAGE} />
            </div>
        </Content>
        <Actions>
            <Button action="close">
                <Label>{$_('chat.ContinueChatting')}</Label>
            </Button>
            <Button action="dialog-confirm" disabled={!endingMessageValid}>
                <Label>{$_('chat.EndChat')}</Label>
            </Button>
        </Actions>
    {/if}
</Dialog>
